module.exports = __webpack_public_path__ + "img/qrcode.f0385643.png";